<template>
    <v-card-text>
        <v-row no-gutters>
            <span
                v-for="(tag, index) in visibleTags"
                :key="`tag-${index}`"
                :style="{ 'background-color': tag.color }"
                class="tag legend" 
            >
                {{ tag.name }}
            </span>
            <span
                v-if="remainingTagCounter"
                class="tag legend remaining"
            >
                +{{ remainingTagCounter }} {{ $t('utils.others') }}
            </span>
        </v-row>
    </v-card-text>
</template>

<script>
    export default {
        name: 'Tags',
        props: {
            tags: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                maxTag: 2
            }
        },
        computed: {
            remainingTagCounter() {
                return this.$props.tags.length > this.maxTag ? this.$props.tags.length - this.maxTag : 0;
            },
            visibleTags() {
                return this.$props.tags.slice(0, this.maxTag);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/components/_tags.scss";
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/components/Tags.vue